import { useParams } from "react-router-dom";
import { Container } from "@mui/material";

import { useUserContext } from "../../../contexts/userContext";

import { DocumentService } from "../../../services/documentService";

import Navigation from "../../header";
import PermissionGate from "../../permissionGate";
import Spinner from "../../spinner";
import Json from "../../json";
import DocumentViewer from "../../documentViewer";

import "../../../styles/documentView.scss";

const DocumentView = () => {
	let { id } = useParams();
	const userContext = useUserContext();

	return (
		<div className="hwi-document-view">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageDocuments}>
					<DocumentViewer documentId={+id} showBackButton={true}></DocumentViewer>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default DocumentView;